module.exports = __webpack_public_path__ + "static/magento_monei-761608a8c8fe58fe1671273315b02ea4.svg";